import React from 'react';

import { IonGrid, IonItem, IonList, IonRow } from '@ionic/react';

import Typography from 'components/Typography';
import { useDateFormat } from 'intl';

import Status from '../Status';

export default ({ data = [] }: any) => {
  const dateFormat = useDateFormat();
  return (
    <>
      <IonList>
        {data.map((row: any, i: number) => {
          const metaLine = `${dateFormat(row.date)} by ${row.user.name}`;
          return (
            <IonItem key={i} lines={'full'} className={'ellipsis'}>
              <IonGrid>
                <IonRow>
                  <Typography variant={'subtitle1'}>{row.action}</Typography>
                </IonRow>
                {row.reasons?.length ? (
                  <IonRow>
                    <Typography variant={'subtitle2'}>
                      {`Reasons: ${row.reasons
                        ?.map(({ name = '' }) => name)
                        .join(', ')}`}
                    </Typography>
                  </IonRow>
                ) : null}
                {row.comment ? (
                  <IonRow>
                    <Typography variant={'subtitle2'}>
                      «{row.comment}»
                    </Typography>
                  </IonRow>
                ) : null}
                <IonRow>
                  <Typography variant={'body2'} color={'medium-shade'}>
                    {metaLine}
                  </Typography>
                </IonRow>
              </IonGrid>
              <Status value={row?.status} slot={'end'} />
            </IonItem>
          );
        })}
      </IonList>
    </>
  );
};
